module.exports = __webpack_public_path__ + "static/media/research-6.88d776e4.svg";